import { MapPin, Phone, Clock, Zap } from "lucide-react";
import { SITE } from "@/lib/siteConfig";

export default function GeoBanner() {
  const headline = "Serrurier en 30 minutes";
  const sub = "Technicien disponible maintenant · intervention < 30 min";

  return (
    <div
      data-testid="geo-banner"
      className="sticky top-16 sm:top-20 z-40 bg-gradient-to-r from-red-600 via-red-600 to-red-700 text-white shadow-lg fade-up"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-4 py-2.5 sm:py-3">
          <div className="flex items-center gap-3 min-w-0">
            <div className="relative hidden sm:flex items-center justify-center w-10 h-10 bg-white/15 border border-white/25 flex-shrink-0">
              <MapPin className="w-5 h-5" strokeWidth={2.5} />
              <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-green-400 rounded-full ring-2 ring-red-600 animate-pulse" />
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-display font-black text-sm sm:text-lg uppercase tracking-tight truncate">
                  {headline}
                </span>
                <span className="hidden md:inline-flex items-center gap-1.5 bg-white/15 border border-white/20 px-2 py-0.5 text-[10px] uppercase tracking-[0.15em] font-bold">
                  <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
                  En ligne
                </span>
                <span className="hidden lg:inline-flex items-center gap-1.5 bg-yellow-400 text-red-900 px-2 py-0.5 text-[10px] uppercase tracking-[0.15em] font-black">
                  <Zap className="w-3 h-3" strokeWidth={3} /> Urgence
                </span>
              </div>
              <div className="flex items-center gap-1.5 text-[11px] sm:text-xs text-red-50 font-medium truncate mt-0.5">
                <Clock className="w-3 h-3" strokeWidth={2.5} />
                {sub}
              </div>
            </div>
          </div>

          <div className="flex items-center flex-shrink-0">
            <a
              href={SITE.phoneHref}
              data-testid="call-cta-geo-banner"
              className="inline-flex items-center gap-2 bg-white hover:bg-yellow-300 text-red-700 px-3 sm:px-5 py-2 sm:py-2.5 font-display font-black text-xs sm:text-sm tracking-tight transition-all hover:-translate-y-0.5 shadow-[0_3px_0_#991B1B]"
            >
              <Phone className="w-4 h-4" strokeWidth={2.5} />
              <span className="hidden sm:inline">{SITE.phone}</span>
              <span className="sm:hidden">Appeler</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
